export default __webpack_public_path__ + "static/media/contact.582fda3b.svg";